"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTableData = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ChevronRight_1 = __importDefault(require("@mui/icons-material/ChevronRight"));
const material_1 = require("@mui/material");
const react_router_1 = require("react-router");
const useGetTableData = (people, page) => {
    const navigate = (0, react_router_1.useNavigate)();
    const LIMIT = 5;
    const initialData = (0, react_router_1.useLoaderData)();
    const teamId = initialData && 'teamId' in initialData && initialData?.teamId;
    if (people && people.length > 0) {
        return (LIMIT > 0 ? people.slice((page - 1) * LIMIT, (page - 1) * LIMIT + LIMIT) : people).map(member => [
            {
                id: 'member',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "column", children: (0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: member?.memberName, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { sx: { width: '200px' }, variant: "subtitle2", "ts-variant": 'tableCellTitleName', children: member?.memberName || '' }) }) }));
                },
            },
            {
                id: 'teamCards',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "column", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle2", "ts-variant": 'tableCellTitle', children: member.activeCardCount }) }));
                },
            },
            {
                id: 'approved',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "column", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { sx: { whiteSpace: 'normal', width: '120px' }, variant: "subtitle2", "ts-variant": 'tableCellTitle', children: member.totalApprovedAmount }) }));
                },
            },
            {
                id: 'spent',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "column", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle2", "ts-variant": 'tableCellTitle', sx: { whiteSpace: 'normal', width: '120px' }, children: member.totalSpentAmount }) }));
                },
            },
            {
                id: 'available',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "column", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle2", "ts-variant": 'tableCellTitle', sx: { whiteSpace: 'normal', width: '120px' }, children: member.totalAvailableBalance }) }));
                },
            },
            {
                id: 'memberActions',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "row", sx: {
                            justifyContent: 'flex-end',
                            alignItems: 'flex-end',
                        }, children: (0, jsx_runtime_1.jsx)(material_1.Button, { "data-testid": "row-actions-btn", variant: "text", "ts-variant": "actionButton", sx: { color: 'hsl(199, 100%, 50%)' }, onClick: () => navigate(`/wallet/team/${teamId}/user/${member.memberId}`), children: (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(ChevronRight_1.default, {}) }) }) }));
                },
            },
        ]);
    }
    return [];
};
exports.useGetTableData = useGetTableData;
